import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import decision from '../services/DecisionService';
import { qi_sections } from '../constants/qi';
import { qi_slice_name, qi_thunks } from '../constants/qi';

const initialState = {
  section: {
    selected: qi_sections[0],
  },
  sections: qi_sections,
  products: {
    life: false,
    lifeEssentials: false,
    ci: false,
    ciEssentials: false,
    aci: false,
    aciEssentials: false,
    ip: false,
  },
  loading: false,
  decision: null,
  quoteDecision: null,
  error: null,
};

export const postDecisionProducts = createAsyncThunk(
  qi_thunks.QI_POST_DECISION_PRODUCTS,
  async ({ applicantId, productTypes }, { rejectWithValue }) => {
    try {
      const response = await decision.postDecisionProducts(
        applicantId,
        productTypes
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postDecisionQiProducts = createAsyncThunk(
  qi_thunks.QI_POST_DECISION_PRODUCTS,
  async ({ applicantId, productTypes }, { rejectWithValue }) => {
    try {
      const response = await decision.postDecisionQiProducts(
        applicantId,
        productTypes
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getApplicantDecisionQuote = createAsyncThunk(
  qi_thunks.QI_GET_APPLICANT_DECISION_QUOTE,
  async ({ applicantId, optOutOflogging }, { rejectWithValue }) => {
    try {
      const response = await decision.getApplicantQiDecisionQuote(
        applicantId,
        optOutOflogging
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getApplicantQiDecisionQuote = createAsyncThunk(
  qi_thunks.QI_GET_APPLICANT_DECISION_QUOTE,
  async ({ applicantId }, { rejectWithValue }) => {
    try {
      const response = await decision.getApplicantQiDecisionQuote(applicantId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const qiSlice = createSlice({
  name: qi_slice_name,
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setSectionDisabled: (state, action) => {
      const index = state.sections.findIndex(
        (section) => section.id === action.payload.id
      );
      if (index !== -1) {
        state.sections[index].disabled = action.payload.disabled;
      }
    },
    setSelectedSection: (state, action) => {
      const selectedSection = state.sections.find(
        (section) => section.id === action.payload
      );
      if (selectedSection) {
        state.section.selected = selectedSection;
      }
    },
    setProducts: (state, action) => {
      state.products = action.payload;
    },
  },
  extraReducers: {
    [postDecisionProducts.pending]: (state) => {
      state.loading = true;
    },
    [postDecisionProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.decision = action.payload.data;
    },
    [postDecisionProducts.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
    [postDecisionQiProducts.pending]: (state) => {
      state.loading = true;
    },
    [postDecisionQiProducts.fulfilled]: (state, action) => {
      state.loading = false;
      state.decision = action.payload.data;
    },
    [postDecisionQiProducts.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
    [getApplicantDecisionQuote.pending]: (state) => {
      state.loading = true;
    },
    [getApplicantDecisionQuote.fulfilled]: (state, action) => {
      state.loading = false;
      state.quoteDecision = action.payload.data;
    },
    [getApplicantDecisionQuote.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
    [getApplicantQiDecisionQuote.pending]: (state) => {
      state.loading = true;
    },
    [getApplicantQiDecisionQuote.fulfilled]: (state, action) => {
      state.loading = false;
      state.quoteDecision = action.payload.data;
    },
    [getApplicantQiDecisionQuote.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
  },
});

export const { reset, setSectionDisabled, setSelectedSection, setProducts } =
  qiSlice.actions;

export default qiSlice;
